export default "/images/clock.svg?c4f567ce2e71bbc75a63791f82c1ec9d";